export enum BadgeStatus {
  Success = 'success',
  Error = 'error',
  Info = 'info',
}

export enum BadgeTone {
  Neutral = 'neutral',
  Success = 'success',
  Warning = 'warning',
  Danger = 'danger',
  Info = 'info',
  Ink = 'ink',
}
